import React from "react";
import { Link } from "react-router-dom";
import { Heart, ShieldCheck, Leaf } from "lucide-react";
import InfoPage from "./Infopage";
import { Helmet } from "react-helmet-async";

// TODO: replace with your real story and values.
const VALUES = [
  {
    icon: Heart,
    title: "Customers first",
    text: "We answer messages quickly and fix problems without the runaround.",
  },
  {
    icon: ShieldCheck,
    title: "Quality you can trust",
    text: "We choose products we'd use ourselves and stand behind every one.",
  },
  {
    icon: Leaf,
    title: "Fair and responsible",
    text: "We work with suppliers who treat people and the environment well.",
  },
];

function OurStory() {
  return (
    <InfoPage
      title="Our story"
      intro="NinetyOne started with a simple idea: shopping should be easy and worth the trust you put in it."
    >
      <Helmet>
        <title>Our Story | Ninety One Clothing Store in Nairobi, Kenya</title>
        <meta
          name="description"
          content="Learn the story behind Ninety One, a Kenyan online store founded in 2024 for streetwear and modern fashion, delivered in Nairobi and across Kenya."
        />
        <link rel="canonical" href="https://ninetyone.co.ke/our-story" />

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "Ninety One",
            url: "https://ninetyone.co.ke",
            foundingDate: "2024",
            description:
              "Kenyan online store for streetwear and modern fashion.",
            areaServed: "KE",
            contactPoint: {
              "@type": "ContactPoint",
              telephone: "+254112866754",
              contactType: "customer service",
              availableLanguage: ["English", "Swahili"],
            },
          })}
        </script>
      </Helmet>
      <section className="info-section info-prose">
        <p>
          Founded in 2024, NinetyOne began as an online store with a handful of
          products and a promise to get the details right.
        </p>
        <p>
          Today we serve customers across Kenya, but the promise hasn't changed.
          Every product is chosen with care, every order is packed with
          attention, and every question gets a real answer.
        </p>
      </section>

      <section className="info-section">
        <h2 className="info-h2">What we stand for</h2>
        <div className="info-grid">
          {VALUES.map(({ icon: Icon, title, text }) => (
            <div key={title} className="info-item">
              <span className="info-icon">
                <Icon aria-hidden="true" />
              </span>
              <h3 className="info-h3">{title}</h3>
              <p>{text}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="info-section">
        <h2 className="info-h2">Come say hello</h2>
        <p className="info-text">
          Visit a store or send us a message. We'd like to hear from you.
        </p>
        <div className="info-actions">
          <Link to="/store-locator" className="info-btn info-btn--primary">
            Find a store
          </Link>
          <Link to="/contact-us" className="info-btn info-btn--secondary">
            Contact us
          </Link>
        </div>
      </section>
    </InfoPage>
  );
}

export default OurStory;
